/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmField } from '../../models/llm-field';

export interface LlmConfigurationGetFieldsLayoutIdGet$Plain$Params {
  layoutId: number;
}

export function llmConfigurationGetFieldsLayoutIdGet$Plain(http: HttpClient, rootUrl: string, params: LlmConfigurationGetFieldsLayoutIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmField>>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationGetFieldsLayoutIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('layoutId', params.layoutId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LlmField>>;
    })
  );
}

llmConfigurationGetFieldsLayoutIdGet$Plain.PATH = '/LLMConfiguration/GetFields/{layoutId}';
